import React from 'react';

type Props = {
  fill?: string;
};

const PaypalPaymentIcon = ({ fill = 'var(--PRIMARY)' }: Props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_12019_281"
      maskUnits="userSpaceOnUse"
      x="4"
      y="4"
      width="24"
      height="24"
    >
      <rect x="4" y="4" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_12019_281)" />
    <path
      d="M12.2219 17.8703C12.0578 18.7703 11.4063 22.9656 11.2141 24.1516C11.2 24.2359 11.1672 24.2688 11.0734 24.2688H7.57657C7.22032 24.2688 6.96251 23.9594 7.00938 23.6172L9.75626 6.18438C9.82657 5.73438 10.2297 5.39219 10.6938 5.39219C17.8328 5.39219 18.4328 5.21875 20.2563 5.92656C23.0734 7.01875 23.3313 9.65313 22.3188 12.5031C21.3109 15.4375 18.9203 16.6984 15.7516 16.7359C13.7172 16.7688 12.4938 16.4078 12.2219 17.8703ZM23.7391 11.125C23.6547 11.0641 23.6219 11.0406 23.5984 11.1859C23.5047 11.7203 23.3594 12.2406 23.1859 12.7609C21.3156 18.0953 16.1313 17.6313 13.6 17.6313C13.3141 17.6313 13.1266 17.7859 13.0891 18.0719C12.0297 24.6531 11.8188 26.0266 11.8188 26.0266C11.7719 26.3594 11.9828 26.6313 12.3156 26.6313H15.2922C15.6953 26.6313 16.0281 26.3359 16.1078 25.9328C16.1406 25.6797 16.0563 26.2188 16.7828 21.6531C16.9984 20.6219 17.4531 20.7297 18.1563 20.7297C21.4844 20.7297 24.0813 19.3797 24.8547 15.4656C25.1594 13.8344 25.0703 12.1188 23.7391 11.125Z"
      fill={fill}
    />
  </svg>
);

export default PaypalPaymentIcon;
